import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import * as FaqAction from '../store/faq';

import FAQListTable from "../component/FAQListTable";
import FAQSearchEngine from "../component/FAQSearchEngine";
import * as apiUtil from "../../../util/apiUtil";
import Loading from "../../../component/loading/Loading";


class FAQListContainer extends React.Component {

    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.handlePageChange = this.handlePageChange.bind(this);

        this.ajaxGetFaqList = this.ajaxGetFaqList.bind(this);
        this.setValue = this.setValue.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);

        this.state={
            loading: false,
            searchKeyword: "",
            searchType: 0,
        }
    }

    componentDidMount() {
        this.ajaxGetFaqList();
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.page !== nextProps.page
            || this.props.size !== nextProps.size
            || this.props.total !== nextProps.total
            || this.props.faqList !== nextProps.faqList
            || this.state.searchType !== nextState.searchType
            || this.state.searchKeyword !== nextState.searchType
        )
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    setValue(id, value) {
        const { FaqAction } = this.props;
        switch (id) {
            case 'searchType':
                this.setState({ searchType: Number(value)}, () => {
                    FaqAction.setPage(1);
                    this.ajaxGetFaqList();
                });
                break;
            case 'searchKeyword':
                this.setState({ searchKeyword: value });
                break;
            default:
                break;
        }
    }

    /* handler */
    async handlePageChange(event, page) {
        const { FaqAction } = this.props;
        const { ajaxGetFaqList } = this;

        await FaqAction.setPage(page);
        ajaxGetFaqList();
    }

    /* handlers */
    handleSearch() {
        const { FaqAction } = this.props;

        FaqAction.setPage(1);
        this.ajaxGetFaqList();
    }

    handleKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleSearch();
        }
    }

    /* ajax request methods */
    ajaxGetFaqList() {
        const { page, size } = this.props;
        const { searchKeyword, searchType } = this.state;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: '/api/faq/list',
            method: apiUtil.requestMethod.POST,
            data: {
                page: page,
                size: size,
                searchKeyword: searchKeyword,
                searchType: searchType,
            },
            success: (result) => {
                const { FaqAction } = this.props;
                FaqAction.setFaqList(result.content);
                FaqAction.setTotal(result.total);
            }
        })
    }


    render() {
        const { total, page, size, faqList, navigate } = this.props;
        const { searchKeyword, searchType } = this.state;
        const { handlePageChange } = this;

        return(
            <React.Fragment>
                <Loading loading={this.state.loading} />
                <div className='container-xxl'>
                    <div className="d-flex justify-content-between align-items-center">
                        <h2 className='fs-4 mb-0'>FAQ</h2>
                    </div>
                    <div className="mx-auto mb-4" style={{ maxWidth: '800px' }}>
                        <FAQSearchEngine
                            searchKeyword={searchKeyword}
                            searchType={searchType}
                            setValue={this.setValue}
                            handleSearch={this.handleSearch}
                            handleKeyDown={this.handleKeyDown}
                        />
                    </div>
                    <div className='card'>
                        <div className='card-body'>
                            <FAQListTable
                                faqList={faqList}
                                total={total}
                                page={page}
                                size={size}
                                setValue={this.setValue}
                                searchType={searchType}
                                handlePageChange={handlePageChange}
                                ajaxGetFaqList={this.ajaxGetFaqList}
                                navigate={navigate}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default connect((state) => ({
        faqList: state.faq.faqList,
        page: state.faq.page,
        size: state.faq.size,
        total: state.faq.total
    }),
    (dispatch) => ({
        FaqAction: bindActionCreators(FaqAction, dispatch)
    })
)(FAQListContainer);
